export const identityPartnerOnboardingConstants = {
    
    GETALLIDENTITYPARTNERONBOARDINGLISTING_REQUEST: 'GETALLIDENTITYPARTNERONBOARDINGLISTING_REQUEST',
    GETALLIDENTITYPARTNERONBOARDINGLISTING_REQUEST_END: 'GETALLIDENTITYPARTNERONBOARDINGLISTING_REQUEST_END',

    GETALLIDENTITYPARTNERONBOARDINGLISTING_SUCCESS: 'GETALLIDENTITYPARTNERONBOARDINGLISTING_SUCCESS',
    GETALLIDENTITYPARTNERONBOARDINGLISTING_FAILURE: 'GETALLIDENTITYPARTNERONBOARDINGLISTING_FAILURE',
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
};
